export const reqHeader_public = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
    "X-PF-Allowed-Proxy": 1,
  },
};

export const reqHeader_public_post = {
  headers: {
    Accept: "application/json",
    "X-PF-Allowed-Proxy": 1,
  },
};

export const reqHeader_jfif = (token: string) => {
  return {
    responseType: "blob",
    headers: {
      "X-Auth-Token": token,
      "X-PF-Allowed-Proxy": 1,
    },
  };
};

export const reqHeader_protected = (token: string) => {  
  return {
    method: 'GET',
    headers: {
      "X-Auth-Token": token,
      //"X-PF-Allowed-Proxy": 1,
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json",
    },
  };
};
